import { render } from "./PartnerReprise.vue?vue&type=template&id=040c2b9d"
import script from "./PartnerReprise.vue?vue&type=script&lang=js"
export * from "./PartnerReprise.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__